import mock from './mock';
import './auth-db';
import './academy-db';

mock.onAny().passThrough();
